import { useColorModeValue } from '@chakra-ui/react';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import {
  flexRender,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from '@tanstack/react-table';

type Props = {
  data: any[],
  columns: any,
  [x: string]: any,
  title?: string,
};

function CustomCardTable({ columns, data, title, ...rest }: Props) {
  // const borderColor = useColorModeValue('gray.300', 'gray.300');
  const table = useReactTable({
    data,
    columns,

    // Pipeline
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    //

    // debugTable: true,
  });

  const bcolor = useColorModeValue(
    'var(--chakra-colors-gray-200)',
    'var(--chakra-colors-gray-700)'
  );

  // Render the UI for your table
  return (
    <>
      <CustomFieldSet
        title={title || ''}
        bg="chakra-body-bg"
        //   boxShadow={{ base: 'none', md: 'base' }}
        boxShadow={'md'}
        // borderTop={`1px solid ${bcolor}`}
        py={5}
        mb={5}
      >
        <CC.TableContainer shadow="sm" {...rest}>
          <CC.Table>
            <CC.Thead>
              {/* TODO: Implement column sorting feature */}
              {table.getHeaderGroups().map((headerGroup) => (
                <CC.Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <CC.Th
                      key={header.id}
                      colSpan={header.colSpan}
                      fontWeight="bold"
                      fontSize={'md'}
                      textTransform='none'
                      border={'none'} textAlign='center'
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </CC.Th>
                  ))}
                </CC.Tr>
              ))}
            </CC.Thead>
            <CC.Tbody color="gray.500">
              {table.getRowModel().rows.map((row, i) => {
                return (
                  <CC.Tr key={row.id}>
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <CC.Td key={cell.id} border={'none'}>
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </CC.Td>
                      );
                    })}
                  </CC.Tr>
                );
              })}
            </CC.Tbody>
          </CC.Table>
        </CC.TableContainer>
      </CustomFieldSet>
    </>
  );
}

export default CustomCardTable;
